module.exports = __webpack_public_path__ + "img/confirmed_us.0fcb95bc.png";